module.exports = __webpack_public_path__ + "src/assets/games/44/40.jpg";